export default __webpack_public_path__ + "static/universities-uk-b4315ae9bbf0e48eebb990cf106626c7.png";